var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"user-select":"none"}},[_vm._t("default"),_c('div',{ref:"observerRef",staticStyle:{"height":"2px","width":"100%"}},[_c('p',{staticClass:"mb-0",staticStyle:{"color":"transparent"}},[_vm._v(" - ")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }